const clickOutside = (el, handler) => {
  const listener = (e) => {
    if (!el || el.contains(e.target)) return;
    handler(e);
    removeListener();
  };

  document.addEventListener("mousedown", listener);
  document.addEventListener("touchstart", listener);

  const removeListener = () => {
    document.removeEventListener("mousedown", listener);
    document.removeEventListener("touchstart", listener);
  };
};

export default clickOutside;
